import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { textChangeRangeIsUnchanged } from 'typescript';
import { LocalStorageService } from '../../services/localstorage/local-storage.service';

interface facilityList {
  id_facility: number;
  id_privileges: number;
  default: number;
}

interface uiXfacilityParams {
  id_facility: number;
  name: string;
  acronym: string;
  privileges: number;
  default: number;
  active: number;
}

@Injectable({
  providedIn: 'root',
})
export class ClientDataService {
  private _id: number;
  private _facility: number;
  private _facility_priviledge = new Array<facilityList>();
  private _uix_facility_list = new Array<uiXfacilityParams>();
  private _uix_facility_list$ = new BehaviorSubject<any[]>([]);
  //private _events$ = new BehaviorSubject<any[]>([]);
  //private _active_facility$ = new BehaviorSubject<uiXfacilityParams>({ acronym: '', active : -1, default: -1, id_facility: -1, name: '', privileges: -1 });
  private _active_facility$ = new BehaviorSubject<any[]>([]);

  constructor(private localStorageService: LocalStorageService) {}

  set id(value) {
    this._id = value;
  }

  get id() {
    return this._id;
  }

  set facility(value) {
    this._facility = value;
  }

  get facility() {
    return this._facility;
  }

  set facility_priviledge(value) {
    this._facility_priviledge = value;
  }

  get facility_priviledge() {
    return this._facility_priviledge;
  }

  setUixFacilityList(data) {
    this._uix_facility_list = [];
    //console.log('setUixFacilityList data');
    //console.log(data);

    let localactiveFacilityId = this.localStorageService.getItem('activeFacilityId');

    //console.log('setUixFacilityList data localactiveFacilityId ' + localactiveFacilityId);
    
    if(localactiveFacilityId !== null){
      for (let facilityResult of data) {
        //console.log('facilityResult data');
        //console.log(facilityResult);
        if(facilityResult.id_facility == localactiveFacilityId)
        {
          this._uix_facility_list.push({
            id_facility: facilityResult.id_facility,
            privileges: facilityResult.privileges,
            default: facilityResult.default,
            active: 1,
            name: facilityResult.name,
            acronym: facilityResult.acronym,
          });
        }else{
          this._uix_facility_list.push({
            id_facility: facilityResult.id_facility,
            privileges: facilityResult.privileges,
            default: facilityResult.default,
            active: 0,
            name: facilityResult.name,
            acronym: facilityResult.acronym,
          });
        }
      }
    }
    else{
      for (let facilityResult of data) {
        //console.log('facilityResult data');
        //console.log(facilityResult);
        this._uix_facility_list.push({
          id_facility: facilityResult.id_facility,
          privileges: facilityResult.privileges,
          default: facilityResult.default,
          active: facilityResult.default,
          name: facilityResult.name,
          acronym: facilityResult.acronym,
        });
      }
    }

    let activeFacility;
    for (let i = 0; i < this.uix_facility_list.length; i++) {
      if (this.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.uix_facility_list[i];
        break;
      }
    }
    
    this._active_facility$.next(activeFacility);

    //console.log('_uix_facility_list data');
    //console.log(this._uix_facility_list);
    this._uix_facility_list$.next(this._uix_facility_list);
  }

  changeActiveFacility(_facility) {
    let oldIdx;
    let newIdx;

    //console.log('antes de procesar this.loggedUser.uix_facility_list');
    //console.log(this.uix_facility_list);
    for (let i = 0; i < this.uix_facility_list.length; i++) {
      //console.log("vuelta : ");
      //console.log(i);
      if (this.uix_facility_list[i]['active'] == 1) {
        //console.log(this.loggedUser.uix_facility_list[i]);
        oldIdx = i;
      }

      if (
        this.uix_facility_list[i]['id_facility'] ==
        Number(_facility.id_facility)
      ) {
        //console.log(this.loggedUser.uix_facility_list[i]);
        newIdx = i;
      }
    }

    /*
    //console.log("oldIdx : ");
    //console.log(oldIdx);
    //console.log("newIdx : ");
    //console.log(newIdx);
    */

    this.uix_facility_list[oldIdx]['active'] = 0;
    this.uix_facility_list[newIdx]['active'] = 1;

    //console.log('changeActiveFacility');
    //console.log('despues de procesar this.loggedUser.uix_facility_list');
    //console.log(this.uix_facility_list);

    this.localStorageService.setItem('activeFacilityId', String(_facility.id_facility));  

    this._active_facility$.next(_facility);
  }

  updateUixFacilityList(data) {
    let activeFacility;
    for (let i = 0; i < this.uix_facility_list.length; i++) {
      if (this.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.uix_facility_list[i];
        break;
      }
    }

    this._uix_facility_list = [];
    for (let facilityResult of data) {
      if (facilityResult.id_facility != activeFacility.id_facility) {
        this._uix_facility_list.push({
          id_facility: facilityResult.id_facility,
          privileges: facilityResult.privileges,
          default: facilityResult.default,
          active: 0,
          name: facilityResult.name,
          acronym: facilityResult.acronym,
        });
      }

      if (facilityResult.id_facility == activeFacility.id_facility) {
        this._uix_facility_list.push({
          id_facility: facilityResult.id_facility,
          privileges: facilityResult.privileges,
          default: facilityResult.default,
          active: 1,
          name: facilityResult.name,
          acronym: facilityResult.acronym,
        });
      }
    }
  }

  get uix_facility_list() {
    return this._uix_facility_list;
  }

  get uix_facility_list$() {
    return this._uix_facility_list$.asObservable();
  }

  get active_facility$() {
    return this._active_facility$.asObservable();
  }

  findActiveUIXFacility() {
    let activeFacility;
    for (let i = 0; i < this._uix_facility_list.length; i++) {
      if (this._uix_facility_list.length[i]['active'] == 1) {
        activeFacility = this._uix_facility_list.length[i];
        break;
      }
    }
    return activeFacility;
  }
}
